import { Grid, Typography } from "@mui/material";
import { IconButtonClose } from "components/iconButtons";
import * as React from "react";

interface IProps {
    children?: React.ReactNode;
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    header?: React.ReactNode;
    footer?: React.ReactNode;
    content?: React.ReactNode;
    footerFullWidth?: boolean;
    onClose?: () => void;
}

export const MprcContainerHCF: React.FC<IProps> = (props) => {

    const { children, header, footer, footerFullWidth, content, title, subtitle, onClose } = props;

    return (
        <Grid
            container
            direction="column"
            wrap="nowrap"
            sx={
                (theme) => (
                    {
                        height: "100%",
                        overflow: "hidden",
                        position: "relative"
                    })
            }
        >
            {
                title &&
                <Grid
                    sx={
                        (theme) => (
                            {
                                backgroundColor: theme.palette.common.white,
                                marginBottom: theme.spacing(),
                                paddingRight: 0
                            })
                    }
                >
                    <Grid container wrap="nowrap" justifyContent="space-between" alignItems="center" >
                        <Grid size="grow">
                            <Typography
                                component="div"
                                noWrap={true}
                                variant="h2"
                                title={typeof (title) == "string" ? title : undefined}
                            >
                                {title}
                            </Typography>
                            {
                                subtitle &&
                                <Typography component="div" noWrap={true} variant="caption" title={typeof (subtitle) == "string" ? subtitle : undefined}>{subtitle}</Typography>
                            }
                        </Grid>
                        {
                            onClose &&
                            <Grid>
                                <IconButtonClose color="muted" size="small" onClick={onClose} />
                            </Grid>
                        }
                    </Grid>
                </Grid>
            }

            <Grid
                size="grow"
                sx={{ position: "relative" }}
            >

                <Grid
                    container
                    direction="column"
                    wrap="nowrap"
                    sx={
                        {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                        }
                    }
                >
                    {
                        header &&
                        <Grid>
                            {header}
                        </Grid>
                    }

                    <Grid
                        size="grow"
                        sx={
                            {
                                overflowX: "hidden",
                                overflowy: "auto",
                                mt: header ? "4px" : undefined
                            }
                        }
                    >
                        {content ?? children}
                    </Grid>

                    {
                        footer &&
                        <Grid alignSelf="center" width={footerFullWidth ? "100%" : undefined}>
                            {footer}
                        </Grid>
                    }
                </Grid>
            </Grid>
        </Grid>
    );
};
